import Yup from "../mixins/yup";

const REQUIRED_MESSAGE = "Campo obrigatório";

export const occupationFilterSchema = Yup.object().shape({
	startDate: Yup.date().required(REQUIRED_MESSAGE).typeError("Data inválida"),
	endDate: Yup.date().required(REQUIRED_MESSAGE).typeError("Data inválida"),
	department: Yup.object().shape({
		label: Yup.string().required(REQUIRED_MESSAGE),
	}),
});
